import React from 'react';
import confirm from './confirm';

export interface AlertOptions {
  message: string | React.ReactElement;
  type?: string,
  buttonText?: string;
}

const alert = (options: AlertOptions) => {
  return confirm({
    title: options.message ?? '',
    type: options.type ?? 'alert' as any,
    primaryClass: 'd-none',
    cancelText: options.buttonText ?? 'باشه',
    onSubmit: () => { }
  })
}

export const errorAlert = (message: string | React.ReactElement) => {
  return alert({  type: 'error', message });
}

export default alert;
